/**
 * GA4 events for the public licensing pages.
 *
 * One guard, one place (see feedback-classify-once-not-at-n-call-sites): every
 * licensing event drops internal traffic AND prerender traffic before it reaches
 * gtag. The prerender guard matters here more than usual — these routes are
 * built to static HTML by a real Chromium at build time, and without it every
 * deploy would log a phantom view of every checked state page.
 */
import { trackGtagEvent } from '@/utils/Analytics';
import { isInternalTraffic } from '@/utils/internalTraffic';
import { isPrerendering } from '@/utils/prerender';

export type LicensingEvent =
  | 'licensing_index_viewed'
  | 'licensing_state_viewed'
  | 'licensing_search'
  | 'licensing_filter'
  | 'licensing_cta_clicked'
  | 'licensing_nav_clicked'
  | 'licensing_checklist_viewed'
  | 'licensing_checklist_submitted';

export function trackLicensing(event: LicensingEvent, params: Record<string, unknown> = {}): void {
  if (isPrerendering() || isInternalTraffic()) return;
  trackGtagEvent(event, params);
}
